// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2lrNK","errorLogs":"EditorFooter_errorLogs__2EojM"};